import React from "react";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";
import { Button } from "@mui/material";

const QRGridPdf = ({
  links,
  rows,
  cols,
  qrWidth = 4,
  qrHeight = 4,
  gapX = 1, // margen horizontal en cm
}) => {
  const generatePdf = async () => {
    const pdf = new jsPDF({ unit: "cm" }); // usamos cm
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    let currentIndex = 0;

    while (currentIndex < links.length) {
      for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
          if (currentIndex >= links.length) break;

          const link = links[currentIndex].url || links[currentIndex];
          const linkText = links[currentIndex].text || "";

          const qrDataUrl = await QRCode.toDataURL(link, { margin: 1 });

          // posición base con margen izquierdo y margen entre columnas
          const x = c * (qrWidth + gapX) + 1;
          const y = r * (qrHeight + 2) + 1; // +2 cm para dejar espacio al texto

          // texto arriba (centrado)
          pdf.setFontSize(8);
          const shortText = linkText; //linkText.length > 30 ? linkText.slice(0, 30) + "..." : linkText;
          const textX = x + qrWidth / 2; // centro de la celda
          pdf.text(shortText, textX, y, { align: "center", maxWidth: qrWidth });

          // QR debajo del texto
          pdf.addImage(qrDataUrl, "PNG", x, y + 0.3, qrWidth, qrHeight);

          currentIndex++;
        }
      }

      if (currentIndex < links.length) {
        pdf.addPage();
      }
    }

    pdf.save("qrcodes.pdf");
  };

  return (
    <Button
      variant="contained"
      size="small"
      onClick={generatePdf}
      sx={{ mr: 1 }}
    >
      Descargar PDF
    </Button>
  );
};

export default QRGridPdf;
